import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import CountUp from 'react-countup'
import { ARM_MORTGAGE_TYPE } from 'src/constants/loan'
import {
  Text,
  If,
  Unless,
  Rate,
  APR,
  InlineBulletedList,
  Format
} from 'src/Components'
import RefiMessages from 'src/Components/shared/InterestSection/RefiByYearsInHome/RefiMessages'

import styles from './RefiDetailsOverlay.module.scss'

const propTypes = {
  details: PropTypes.shape({
    type: PropTypes.string,
    years: PropTypes.number,
    longterm: PropTypes.number,
    rate: PropTypes.number,
    apr: PropTypes.number,
    yearsInHome: PropTypes.number
  }),
  prevNumber: PropTypes.number
}

const RefiDetailsHeader = ({ prevNumber, ...details }) => {
  const { type, years, longterm, rate, apr, yearsInHome } = details

  let color
  const bad = longterm <= 0
  const caution = type === ARM_MORTGAGE_TYPE && yearsInHome > years
  if (bad) {
    color = 'red'
  } else if (caution) {
    color = 'orange'
  } else {
    color = 'green'
  }

  return (
    <div className={styles.header}>
      <div className={styles.deets}>
        <Text size='l'>
          <RefiMessages.LoanName type={type} years={years} />
        </Text>
      </div>
      <div className={styles.longterm}>
        <Text size='xxl' weight='light' color={color}>
          <CountUp
            start={prevNumber}
            end={longterm}
            duration={0.5}
            formattingFn={Format.currency}
          />
        </Text>
        <If condition={caution}>
          <Text
            className={styles.armCaution}
            size='s'
            color={color}
            weight='semibold'
          >
            <Unless condition={bad}>
              <FormattedMessage
                id='Refinance.savings.armLock.caution'
                defaultMessage='Saved Over {years} Years'
                values={{ years }}
              />
            </Unless>
            <If condition={bad}>
              <FormattedMessage
                id='Refinance.savings.armLock.bad'
                defaultMessage='Lost Over {years} Years'
                values={{ years }}
              />
            </If>
          </Text>
        </If>
      </div>
      <Text color='quiet' element='div' className={styles.deets}>
        <InlineBulletedList>
          <Rate value={rate} />
          <APR value={apr} />
        </InlineBulletedList>
      </Text>
    </div>
  )
}

RefiDetailsHeader.propTypes = propTypes

export default RefiDetailsHeader
